<template>
    <ul class="uk-list uk-list-divider">
    <p class="uk-text-center"><span v-if="message" class="uk-text-small uk-text-light" :class="message.type">{{message.text}}</span></p>
        <template v-if="isManager || isAdmin">
          <li v-for="assessment in assessments" :key="assessment.id">
            <div class="" uk-grid>
                <div class="uk-width-5-6@m">
                    <h4>{{assessment.title}}</h4>
                    <p class="s-name">{{assessment.description}}</p>
                </div>
                <div class="uk-width-1-6@m uk-align-center">
                    <a href="" class="uk-icon-button uk-button-primary uk-margin-small-right" uk-icon="play" uk-tooltip="Start assessment" @click.prevent="startAssessment(assessment.id)" v-if="currentRouteName === 'dashboard'"></a>
                    <a href="" class="uk-icon-button uk-button-primary uk-margin-small-right" uk-icon="pencil" uk-tooltip="Edit assessment" @click.prevent="updateAssessment(assessment.id)" v-if="currentRouteName === 'management'"></a>
                    <a href="" class="uk-icon-button uk-button-primary" uk-icon="trash" uk-tooltip="Delete assessment" @click.prevent="deleteAssessment(assessment.id)"  v-if="currentRouteName === 'management'"></a>
                </div>
            </div>
          </li>
        </template>
        <template v-else>
           <template v-if="currentUser.attempt <= 6">
                <li v-for="(assessment, index) in assessments" :key="index">
                    <div class="" uk-grid v-if="(currentUser.attempt % 2) === index">
                        <div class="uk-width-5-6@m">
                            <h4>{{assessment.title}}</h4>
                            <p class="s-name">{{assessment.description}}</p>
                        </div>
                        <div class="uk-width-1-6@m uk-align-center">
                            <a href="" class="uk-icon-button uk-button-primary uk-margin-small-right" uk-icon="play" uk-tooltip="Start assessment" @click.prevent="startAssessment(assessment.id)"></a>
                        </div>
                    </div>
                </li>
           </template>
            <li v-else>
                <div class="uk-placeholder uk-text-center" style="color: #8a959b; line-height: 22px;">
                    All attempts used.
                </div>
            </li>
      </template>
        <li class="uk-text-center uk-margin-top" v-if="(isAdmin || isManager) && (currentRouteName === 'management')">
            <router-link to="/assessment/create" class="uk-button uk-button-primary">Create new Assesment</router-link>
        </li>
    </ul>
</template>

<script>
import AssessmentService from '@/services/assessment.service';
export default {
    name: 'ListAssesments',
    data() {
        return {
            assessments: [],
            message: ''
        }
    },
    mounted() {
        this.getAssessments();
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        isManager() {
           if (this.currentUser && this.currentUser.roles) {
                return this.currentUser.roles.includes('manager');
            }
            return false;
        },
        isAdmin() {
           if (this.currentUser && this.currentUser.roles) {
                return this.currentUser.roles.includes('admin');
            }
            return false;
        },
        currentRouteName() {
            return this.$route.name;
        }
    },
    created() {
        setInterval(() => {
            this.message = null;
        }, 10000)
    },
    methods: {
        getAssessments() {
            AssessmentService.all().then(
            res => {
                this.assessments = res.data;
                this.message = {text: res.data.message, type: 'uk-text-success'}
            },
            error => {
                let message = (error.response && error.response.data.message.message) || error.message || error.toString();
                this.message = {text: message, type: 'uk-text-danger'}
            }
            )
        },
        startAssessment(id) {
             this.$router.push({ name: 'assessment.start', params: { id: id } });
        },
        updateAssessment(id){
            this.$router.push({ name: 'assessment.update', params: { id: id } });
        },
        deleteAssessment(id){
            AssessmentService.delete(id).then(
            res => {
              this.assessments = res.data.assessments;
              this.message = {text: res.data.message, type: 'uk-text-success'}
            },
            error => {
              let message = (error.response && error.response.data.message.message) || error.message || error.toString();
              this.message = {text: message, type: 'uk-text-danger'}
            }
          ) 
        }
    },
}
</script>

<style>

</style>